import { isDevelopment } from "./runtimeEnv";
export const logDataToConsole = (
  message = "",
  valueToLog: any = "",
  loggerType: "info" | "warn" | "error" | "log" = "log",
) => {
  if (isDevelopment()) {
    console[loggerType](message, valueToLog);
  }
};

export const logError = (error: Error, additionalInfo: any = "") => {
  // Filter out localStorage ReferenceErrors: Web workers don't have access to localStorage,
  // so these errors are expected and should not clutter the console. Other errors are still logged.
  if (
    error instanceof ReferenceError &&
    error.message.includes("localStorage")
  ) {
    return;
  }

  if (isDevelopment()) {
    console.error(
      "Error:",
      error.message,
      "\nStack Trace:",
      error.stack,
      "\nAdditional Info:",
      additionalInfo,
    );
  }
};
